import { Component, computed, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { TextImageComponent } from '@content/ui/text-image';
import {
  TextField,
  ImageField,
  RichTextField,
  LinkField,
} from '@core/jss-proxy';

@Component({
  selector: 'wl-text-image-container',
  templateUrl: './text-image.container.component.html',
  standalone: true,
  imports: [TextImageComponent],
})
export class TextImageContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();

  readonly inverse = computed(
    () => this.rendering().params?.['ShowInverse'] === '1'
  );

  readonly fields = computed(() => this.rendering().fields);
  readonly title = computed(() => this.getField<TextField>('Title'));
  readonly content = computed(() => this.getField<RichTextField>('Content'));
  readonly image = computed(() => this.getField<ImageField>('Image'));
  readonly primaryButton = computed(() =>
    this.getField<LinkField>('PrimaryButton')
  );
  readonly secondaryButton = computed(() =>
    this.getField<LinkField>('SecondaryButton')
  );
  readonly microcopy = computed(() => this.getField<TextField>('Microcopy'));

  private getField<T>(
    field:
      | 'Title'
      | 'Content'
      | 'Image'
      | 'Microcopy'
      | 'PrimaryButton'
      | 'SecondaryButton'
  ): T | undefined {
    const fields = this.fields();
    if (fields) {
      return fields[field] as T | undefined;
    }
    return undefined;
  }
}
